import {
  AssignableRole,
  ROLE_REGISTRY,
  RoleGroup,
  RoleRegistryEntry,
} from 'src/common/roleRegistry/roleRegistry';
import { variables } from 'src/Tenants';

export const getGroupRetentionCallout = (group: RoleGroup): string => {
  if (group === 'property-scoped') {
    return "This user's property associations for their current role will be preserved and restored if they return to it later.";
  }

  return "This user's unit associations for their current role will be preserved and restored if they return to it later.";
};

export const getRoleDefinition = (
  role: string
): RoleRegistryEntry | undefined =>
  ROLE_REGISTRY.find((def) => def.id === role);

export const getRoleDisplayLabel = (role: string): string => {
  switch (role) {
    case 'Property Developer':
      return variables.propertyDeveloper;
    case 'Home Owner':
      return variables.homeOwner;
    case 'Strata Manager':
      return variables.strataManager;
    default:
      return role;
  }
};

export const getAssignableRolesInSameGroup = (
  currentRole: string
): readonly AssignableRole[] => {
  const currentRoleEntry: RoleRegistryEntry | undefined =
    getRoleDefinition(currentRole);

  if (!currentRoleEntry) {
    return [];
  }

  const targetGroup: RoleGroup = currentRoleEntry.group;
  const otherRolesInGroup: AssignableRole[] = [];

  for (const candidate of ROLE_REGISTRY) {
    const isInTargetGroup: boolean = candidate.group === targetGroup;
    const isCurrentRole: boolean = candidate.id === currentRole;

    if (!isInTargetGroup) {
      continue;
    }

    if (isCurrentRole) {
      continue;
    }

    otherRolesInGroup.push(candidate.id);
  }

  return otherRolesInGroup;
};
